import { type ModalBaseProps } from '../types.js';
import { CloseIcon } from '@contra/icons/icons';
import { forwardRef, type Ref } from 'react';
import { css, styled } from 'styled-components';

type CloseIconColor = 'black' | 'white';

const Container = styled.button<{ customTopOffset?: string }>`
  ${({ customTopOffset, theme }) => css`
    position: absolute;
    top: ${customTopOffset ? customTopOffset : '24px'};
    right: 24px;
    z-index: ${theme.zIndices.modal.dialog + 1};
  `}
`;

const StyledCloseIcon = styled(CloseIcon)<{ $color?: CloseIconColor }>`
  ${({ $color, theme }) => css`
    color: ${$color ? theme.colorsV2[$color] : undefined};
  `}
`;
export const ModalCloseButton = forwardRef(
  (
    {
      closeIconColor,
      customTopOffset,
      onClose,
      ...props
    }: {
      readonly closeIconColor?: CloseIconColor;
      readonly customTopOffset?: string;
      readonly onClose: ModalBaseProps['onClose'];
    },
    ref?: Ref<HTMLButtonElement>,
  ) => {
    return (
      <Container
        aria-label="Close modal"
        onClick={onClose}
        {...props}
        customTopOffset={customTopOffset}
        ref={ref}
      >
        <StyledCloseIcon
          $color={closeIconColor}
          size={24}
        />
      </Container>
    );
  },
);
